import { useEffect, useState, type MutableRefObject } from 'react';

export const useContentOverflow = (
  sideDrawerRef: MutableRefObject<HTMLElement>,
  deps: any[] = []
) => {
  const [contentOverflow, setContentOverflow] = useState(false);

  useEffect(() => {
    if (!sideDrawerRef?.current) return;
    const element = sideDrawerRef.current;
    const isOverflown =
      element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    setContentOverflow(isOverflown);
  }, [...deps]);

  return contentOverflow;
};
